import { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useAppSelector } from "../../store/hooks";
import UpdateProfile from "./UpdateProfile";
import SwitchRole from "../../components/SwitchRole";

export default function DoctorDashboard() {
  const user = useAppSelector((s) => s.auth.user);
  const phone = user?.phone;
  const [doctorProfile, setDoctorProfile] = useState({ name: "" });
  const [loading, setLoading] = useState(false);

  async function loadDoctorProfile() {
    try {
      setLoading(true);
      const res = await axiosInstance.get("/profile/doctor");
      if (!res.data.data) return;

      const data = res.data.data;

      setDoctorProfile(data)
      setLoading(false);

    } catch (err) {
      console.error(err);
    }
  }



  useEffect(() => {
    loadDoctorProfile();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-indigo-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-indigo-600">
          Doctor Dashboard
        </h1>
        <p className="mt-4 text-gray-600">
          Welcome Doctor ({phone})
        </p>
        <SwitchRole />
      </div>
      {loading === false && !doctorProfile.name && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg max-h-[90vh] overflow-y-auto w-full max-w-xl">
            <UpdateProfile />
          </div>
        </div>
      )}
    </div>
  );
}